export default {
	evirPx_Severity: "Severity",
	evirPx_Date: "Date",
	evirPx_Time: "Time",
	evirPx_Asset_Number: "Asset Number",
	evirPx_Asset_Type: "Asset type",
	evirPx_Insp_Name: "Insp. Name",
	evirPx_Insp_Type: "Insp. Type",
	evirPx_Inspector: "Inspector",
	evirPx_Asset_Location: "Asset Location",
	evirPx_No_Results_Found: "No results found",
	evirPx_User_Created_Asset: "User Created Asset",
	evirPx_Incomplete_Inspection: "Incomplete Inspection",
	evirPx_Additional_Asset_Information: "Additional Asset Information",
	evirPx_inspection_history: "Inspection History",
	evirPx_records: "records",
	evirPx_record: "record",
	evirPx_total: "total",
	evirPx_failed: "failed",
	evirPx_failed_inspections_detected: "Failed Inspections Detected",
	evirPx_unique_issues_bulk_fix: "unique issues can be fixed in bulk",
	evirPx_inspection: "inspection",
	evirPx_inspections: "inspections",
	evirPx_affected_by_issue: "affected by this issue",
	evirPx_fix_all: "Fix All",
	evirPx_failed_inspection: "Failed Inspection",
	evirPx_fix_inspection: "Fix Inspection",
	evirPx_fix_inspection_description: "Review and confirm the suggested fix for this failed inspection.",
	evirPx_issue: "Issue",
	evirPx_suggested_driver: "Suggested Driver",
	evirPx_high_confidence: "high confidence",
	evirPx_is_this_correct: "Is this correct? If not, please choose the correct driver:",
	evirPx_use_suggested: "Use suggested",
	evirPx_select_different_driver: "Select different driver...",
	evirPx_cancel: "Cancel",
	evirPx_apply_fix: "Apply Fix",
	evirPx_actions: "Actions",
	evirPx_fix: "Fix",
	evirPx_reload: "Reload",
	evirPx_delete: "Delete",
	evirPx_delete_inspection_record: "Delete Inspection Record?",
	evirPx_action_cannot_be_undone: "This action cannot be undone",
	evirPx_fmcsa_compliance_warning: "FMCSA Compliance Warning:",
	evirPx_delete_compliance_warning: "Deleting inspections may remove FMCSA-required data. This could impact your compliance record and audit trail.",
	evirPx_inspection_to_delete: "Inspection to be deleted:",
	evirPx_status: "Status",
	evirPx_date_time: "Date/Time",
	evirPx_driver_tag: "Driver Tag",
	evirPx_asset_tag: "Asset Tag",
	evirPx_division: "Division",
	evirPx_certify_delete: "I certify this update is true and acknowledge that removing this inspection data may affect compliance records.",
	evirPx_delete_inspection: "Delete Inspection",
	evirPx_failed_inspection_not_fixed: "The failed inspection has not been fixed.",
	evirPx_Verification_Type: "Verification type",
	evirPx_Incomplete: "Incomplete",
	evirPx_Unverified: "Unverified",
	evirPx_Multiple: "Multiple",
	evirPx_Search: "Search",
	evirPx_Clear_Selected: "Clear Selected",
	evirPx_Cancel: "Cancel",
	evirPx_Apply: "Apply",
	evirPx_Major_Defects: "Major Defects",
	evirPx_Minor_Defects: "Minor Defects",
	evirPx_No_Defects: "No Defects",
	evirPx_Inspection_Name: "Inspection name",
	evirPx_Inspection_Type: "Inspection type",
	evirPx_Date_Range: "Date range",
	evirPx_Date_Range_Today: "Today",
	evirPx_Date_Range_Previous_7: "Prev 7 days",
	evirPx_Date_Range_Previous_14: "Prev 14 days",
	evirPx_Date_Range_Previous_30: "Prev 30 days",
	evirPx_Date_Range_Previous_365: "Prev 365 days",
	evirPx_Date_Range_Custom: "Custom",
	evirPx_Assets: "Assets",
	evirPx_Inspectors: "Inspectors",
	evirPx_Divisions: "Divisions",
	evirPx_Tags: "Tags",
	evirPx_Search_To_Filter: "Search to filter",
	evirPx_export_selected_csv: "Export selected (CSV)",
	evirPx_export_all_csv: "Export all (CSV)",
	evirPx_Clear_Filters: "Clear Filters",
	evirPx_Tag: "Tag",
};
